import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled, { css } from 'styled-components'

import { Trend } from '@root/entities/trend'
import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import { TradePositionDetails } from './trade-position-details'
import { TradePositionDetailsAction } from './trade-position-details/trade-position-details-action'
import { TradePositionHeader } from './trade-position-header'

import type { AggregatedPositionModel } from '@root/entities/position'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'> & {
  position: AggregatedPositionModel
  onEditClick?: () => void
}

export const TradePositionDrawer: React.FC<Props> = ({
  position,
  open,
  onOpenChange,
  onEditClick,
}) => {
  const { t } = useTranslation()
  const [_closePositionOpen, setClosePositionOpen] = useState(false)
  const [pnlUsd] = useAtom(position.pnlUsd)

  const pnlTrend = Trend.of(pnlUsd.pnlPercentage)

  return (
    <>
      <Root
        open={open}
        onOpenChange={onOpenChange}
        title={t('position.position-details')}
        $pnl={pnlTrend}
      >
        <Content>
          <TradePositionHeader position={position} />
          <TradePositionDetails position={position} />
          <TradePositionDetailsAction
            position={position}
            onEditClick={onEditClick}
            onCloseClick={() => {
              setClosePositionOpen(true)
            }}
          />
        </Content>
      </Root>

      {/* // TODO: Fix! Dump position here? */}
      {/* <AnimatePresence>
        <ClosePositionDrawer
          open={closePositionOpen}
          onOpenChange={setClosePositionOpen}
          position={position}
        />
      </AnimatePresence> */}
    </>
  )
}

const Root = styled(Drawer)<{ $pnl: Trend.Trend }>`
  --pnl-color: ${({ $pnl }) =>
    $pnl === Trend.Down ? 'var(--down-9)' : 'var(--up-9)'};

  ${({ $pnl }) => {
    if ($pnl !== Trend.Down) {
      return css`
        background:
          radial-gradient(
            44.96% 25.22% at 50% 0%,
            rgba(var(--upAccent-9-rgb), 0.2) 0%,
            rgba(var(--upAccent-9-rgb), 0) 100%
          ),
          var(--background-1);
      `
    }
    return css`
      background:
        radial-gradient(
          44.96% 25.22% at 50% 0%,
          rgba(var(--downAccent-9-rgb), 0.2) 0%,
          rgba(var(--downAccent-9-rgb), 0) 100%
        ),
        var(--background-1);
    `
  }}

  height: var(--max-drawer-height);
`

const Content = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;

  height: 100%;
`
